import React, { useState } from 'react';

function getYoutubeEmbed(url) {
  if (!url) return null;
  const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([^&?/]+)/);
  if (m) return `https://www.youtube.com/embed/${m[1]}`;
  if (url.includes('vimeo.com')) {
    const v = url.match(/vimeo\.com\/(\d+)/);
    if (v) return `https://player.vimeo.com/video/${v[1]}`;
  }
  return null;
}


function PostModal({ post, onClose, settings }) {
  const [imgIdx, setImgIdx] = useState(0);
  const embedUrl = getYoutubeEmbed(post.video_url);
  const hasImages = post.images && post.images.length > 0;

  return (
    <div className="post-modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="post-modal">

        {/* Media */}
        <div className="post-modal-media">
          {embedUrl ? (
            <iframe src={embedUrl} title={post.title} allowFullScreen />
          ) : hasImages ? (
            <>
              <img src={post.images[imgIdx]} alt={`slide-${imgIdx}`} />
              {post.images.length > 1 && (
                <>
                  <button className="modal-gallery-nav prev" onClick={() => setImgIdx(i => (i - 1 + post.images.length) % post.images.length)}>‹</button>
                  <button className="modal-gallery-nav next" onClick={() => setImgIdx(i => (i + 1) % post.images.length)}>›</button>
                  <div className="modal-dots">
                    {post.images.map((_, i) => <span key={i} className={i === imgIdx ? 'active' : ''} />)}
                  </div>
                </>
              )}
            </>
          ) : (
            <div style={{ color: '#333', fontSize: '3rem' }}>🎬</div>
          )}
        </div>

        {/* Side */}
        <div className="post-modal-side">
          <div className="post-modal-header">
            <div className="post-modal-avatar">
              {settings?.logo_circular_url || settings?.logo_url
                ? <img src={settings.logo_circular_url || settings.logo_url} alt="logo" />
                : '🎬'}
            </div>
            <span className="post-modal-username">{settings?.site_title || '369Films'}</span>
            <button className="post-modal-close" onClick={onClose}>×</button>
          </div>

          <div className="post-modal-body">
            <h3>{post.title}</h3>
            {post.description && <p style={{ marginTop: '.5rem' }}>{post.description}</p>}
          </div>

          <div className="post-modal-date">
            {new Date(post.created_at).toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
          </div>
        </div>

      </div>
    </div>
  );
}

export default function PostCard({ post, settings }) {
  const [open, setOpen] = useState(false);
  const embedUrl  = getYoutubeEmbed(post.video_url);
  const hasImages = post.images && post.images.length > 0;
  const thumb     = hasImages ? post.images[0] : null;

  return (
    <>
      <div className="grid-item" onClick={() => setOpen(true)}>
        {thumb ? (
          <img src={thumb} alt={post.title} />
        ) : embedUrl ? (
          <div style={{ width:'100%', height:'100%', background:'#111', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'2.5rem' }}>▶</div>
        ) : (
          <div style={{ width:'100%', height:'100%', background:'#111', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'2.5rem' }}>🎬</div>
        )}

        {/* Badge múltiples fotos o video */}
        {hasImages && post.images.length > 1 && (
          <span className="grid-item-badge">⧉</span>
        )}
        {embedUrl && (
          <span className="grid-item-badge">▶</span>
        )}

        <div className="grid-item-overlay">
          <span>🎬 {post.title}</span>
        </div>
      </div>

      {open && <PostModal post={post} onClose={() => setOpen(false)} settings={settings} />}
    </>
  );
}
